import React from 'react';
import PropTypes from 'prop-types';
import Router from 'next/router';
import Head from 'next/head';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import consumeAppContext from '../consumers/app';
import { buildTitle } from '../utils/layout';
import Main from './main';

const useStyles = makeStyles((theme) => ({
  loginButton: {
    margin: theme.spacing(1, 0, 4, 0)
  }
}));

const LoginRequired = ({ login }) => {
  const classes = useStyles();

  return (
    <Main>
      <Head>
        <title>{buildTitle('Login Required')}</title>
      </Head>

      <Typography variant="h1">Login Required</Typography>

      <p>You must log in to use this page.</p>

      <Button
        onClick={(e) => {
          e.preventDefault();
          login(Router.asPath);
        }}
        variant="contained"
        color="primary"
        className={classes.loginButton}
      >
        Log In to Continue
      </Button>
    </Main>
  );
};

LoginRequired.propTypes = {
  login: PropTypes.func
};

export default consumeAppContext(LoginRequired);
